import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchRmsPosProducts = createAsyncThunk(
  "api/RmsPOSProducts/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get("/api/RmsPOSProducts");
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const rmsPosProductsSlice = createSlice({
  name: "rmsPosProducts",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRmsPosProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchRmsPosProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchRmsPosProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default rmsPosProductsSlice.reducer;
export const selectRmsPosProductsRows = (state) => state.rmsPosProducts.rows;
export const selectRmsPosProductsStatus = (state) => state.rmsPosProducts.status;
